/* eslint-disable react/jsx-pascal-case */
import { Col, DatePicker, ConfigProvider, Form, Input, Row, Button, Select } from "antd";
import dayjs from 'dayjs';
import React, { useEffect, useState, useRef } from "react";
// import Label_language from '../../language'
// import UploadImg from '../../utility/UploadImg'
import JoditEditor from "jodit-react";
const { ConfigContext } = ConfigProvider

const RoomForm = (
    {
        propsForm = null,
        formReloadCount = 0,
        onFormFinish = () => { },
    }
) => {
    const [form] = Form.useForm();
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        })

    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        setFormValuesOtherThings(formValues)
    }
    const onContentChange = (content) => {
    }
    const disabledDate = (current) => {
        // Can not select days before today and today
        return current && current < dayjs().subtract(1, "day").endOf('day');
    };
    const range = (start, end) => {
        const result = [];
        for (let i = start; i < end; i++) {
            result.push(i);
        }
        return result;
    };

    const disabledDateTime = (current) => ({
        disabledHours: () => {
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            if (todayDate === currentDate) {
                return range(0, 24).splice(0, parseInt(hour))
            }
            else {
                return range(0, 24).splice(0, 0)
            }
        },
        disabledMinutes: () => {
            let minutes = dayjs().format("mm")
            let hour = dayjs().format("HH")
            let todayDate = dayjs().format('YYYY-MM-DD')
            let currentDate = dayjs(current).format('YYYY-MM-DD')
            let currentHour = dayjs(current).format('HH')
            console.log({minutes})
            if (todayDate === currentDate &&  currentHour === hour) {
                return range(0, 60).splice(0, parseInt(minutes)+5) 
            }
            else {
                return range(0, 0)
            }
        },
        disabledSeconds: () => {
            return range(0, 0)
        },
    });
    useEffect(() => {
        setDataInitialization()
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        // setFormValuesOtherThings(formValues)
    }, [formReloadCount])

    return (
        <Row>

            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={"room_id"}

                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"標題"}
                                name={"name"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"編號"}
                                name={"code"}
                                rules={[
                                    {
                                        required: true,
                                        message: "請輸入"
                                    }
                                ]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>


    )
}


export default RoomForm;
